import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { ListMetadata } from '../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { publishReplay, refCount } from 'rxjs/operators';
import { ImportGift } from 'app/models/import-gift.model';

@Injectable()
export class LoyaltyImportGiftService {

  baseUrl = HttpClientService.BASE_MS_PROMO;
  cachedImportGift: Observable<ImportGift>;

  constructor(
    private http: HttpClientService
  ) { }

  /**
      * Tramite metodo GET, restituisce la lista delle importazioni
      * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
    */
   list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<ImportGift>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + `/catalogImportGift/header` +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }


   /**
     * Tramite metodo GET carico i campi del dto di ImportGift in un Observable
     * @returns il dto Import Gift
     */
    getImportFields() {
      if (!this.cachedImportGift) {
        this.cachedImportGift= this.http.get(`${this.baseUrl}/schema/CatalogGiftImportHeadDto`).pipe(
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
        )
      }
      return this.cachedImportGift;
    }

    /**
     * Tramite chiamata POST viene mandato il file sottoforma di json nel body
     * @param giftData il json 
     * @returns 
     */
    importGift(giftData, headId){
      return this.http.post(`${this.baseUrl}/catalogImportGift/addDetail/${headId}`, giftData);
    }

    importCatalog(data: FormData) {
      //let data: FormData = new FormData;
      // data.append('excel', fileExcel, fileExcel.name);
      // images.forEach(img => data.append('image', img, img.name));
      return this.http.upload(`${this.baseUrl}/catalogImportGift/importCatalogFromFiles`, data);
    }

    importGiftHead(headImport){
      return this.http.post(`${this.baseUrl}/catalogImportGift/`, headImport);
    }

    deleteImport(headId){
      return this.http.delete(`${this.baseUrl}/catalogImportGift/${headId}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-import-gift.service.ts